export const maxWebWidth = '70%'
export const maxMobileWidth = '100%'
export const maxButtonWidth = '97%'
export const maxButtonWebWidth = '20%'
export const maxButtonWebWidth1 = '30%'